var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPreview = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-4.8%",
    y: "-27.3%",
    width: "109.6%",
    height: "154.5%",
    filterUnits: "objectBoundingBox",
    id: "7ngjc0n7sa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.133333333 0 0 0 0 0.133333333 0 0 0 0 0.133333333 0 0 0 0.2 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#7ngjc0n7sa)",
    transform: "translate(-9 5)",
    fill: "#AEAEBD",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.724 17.429-1.517.76-.759 1.52a.5.5 0 0 1-.894 0l-.759-1.52-1.517-.76a.5.5 0 0 1 0-.896l1.517-.76.759-1.519c.17-.339.724-.339.894 0l.759 1.52 1.517.76a.5.5 0 0 1 0 .895zm-2.114-.836a.503.503 0 0 1-.223-.224L31 15.598l-.386.773a.503.503 0 0 1-.223.222l-.773.387.773.388a.506.506 0 0 1 .223.224l.386.773.386-.772a.506.506 0 0 1 .223-.224l.773-.388-.773-.388zm-3.332 9.952 1.517-.76.759-1.519c.17-.34.724-.34.894 0l.759 1.52 1.517.76a.5.5 0 0 1 0 .895l-1.517.76-.759 1.519a.5.5 0 0 1-.894 0l-.759-1.52-1.517-.76a.5.5 0 0 1 0-.895zm2.114.835a.505.505 0 0 1 .223.224l.386.773.386-.773a.505.505 0 0 1 .223-.224l.773-.387-.773-.387a.505.505 0 0 1-.223-.224L31 25.61l-.386.772a.505.505 0 0 1-.223.224l-.773.387.773.387zM32 21.987c0-.19.107-.363.276-.448l3.517-1.759 1.758-3.523c.17-.34.725-.34.895 0l1.758 3.523 3.517 1.76a.5.5 0 0 1 0 .895l-3.517 1.76-1.758 3.522a.5.5 0 0 1-.895 0l-1.758-3.521-3.517-1.76a.503.503 0 0 1-.276-.449zm4.39 1.388a.503.503 0 0 1 .223.224L38 26.374l1.385-2.775a.503.503 0 0 1 .224-.224l2.772-1.388-2.772-1.388a.506.506 0 0 1-.224-.224L38 17.6l-1.386 2.775a.506.506 0 0 1-.223.224l-2.772 1.388 2.772 1.388z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPreview, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/preview.1b45b3df.svg";
export { ForwardRef as ReactComponent };